var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E0690F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.57031C12.0685 6.57031 12.1361 6.58383 12.1992 6.60938L12.2607 6.63867C12.3204 6.67229 12.3726 6.71728 12.415 6.77051L12.4541 6.82617L18.9277 17.6348H18.9287C18.9634 17.6948 18.9859 17.7608 18.9951 17.8291L19 17.8984C19.0002 17.9678 18.9869 18.0367 18.9609 18.1006L18.9307 18.1631C18.8961 18.2237 18.8496 18.2768 18.7949 18.3193L18.7383 18.3584C18.6584 18.4054 18.5673 18.4306 18.4746 18.4316H5.52539C5.45603 18.4309 5.38769 18.4165 5.32422 18.3896L5.26172 18.3584C5.20157 18.323 5.14925 18.276 5.10742 18.2207L5.06934 18.1631C5.03497 18.1027 5.01268 18.0363 5.00391 17.9678L5 17.8984C5.00023 17.8288 5.01444 17.7602 5.04102 17.6963L5.07129 17.6348L11.5459 6.82617C11.5815 6.76751 11.6279 6.71653 11.6826 6.67578L11.7393 6.63867C11.7989 6.6051 11.8642 6.58296 11.9316 6.57422L12 6.57031Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5703L12.002 13.0703",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 15.3691H12.0086",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.6925a9d46cc7059d7a1023c89dda2cb7.svg";
export { ForwardRef as ReactComponent };